import { APPLE_CODE, GOOGLE_TOKEN } from './serve/consts';
import { get, remove, set } from './serve/localStorage';

export function getGoogleToken() {
  return get<string>(GOOGLE_TOKEN);
}

export function setGoogleToken(token: string) {
  set(GOOGLE_TOKEN, token);
}

export function removeGoogleToken() {
  remove(GOOGLE_TOKEN);
}

export function getAppleCode() {
  return get<string>(APPLE_CODE);
}

export function setAppleCode(token: string) {
  set(APPLE_CODE, token);
}

export function removeAppleCode() {
  remove(APPLE_CODE);
}
